export default class OutsideClick {
    constructor(element, callback, bubbling = true) {
        this.element = element;
        this.callback = callback;
        this.bubbling = bubbling;

        this.handle = this.handle.bind(this);
    }

    handle(event) {
        if (!this.element.contains(event.target)) {
            this.callback(event);
        }
    }

    register() {
        window.addEventListener('click', this.handle, this.bubbling);
    }

    unregister() {
        window.removeEventListener('click', this.handle, this.bubbling);
    }
}
